export default "__VITE_ASSET__CJK4osAr__"